import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SuccessScreen.css";

export const SuccessScreen: React.FC = () => {
  const { t } = useTranslation();
  const [checkmarkDrawn, setCheckmarkDrawn] = useState(false);

  useEffect(() => {
    // Trigger checkmark animation after mount
    const timer = setTimeout(() => {
      setCheckmarkDrawn(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="success-screen">
      <div className="success-content">
        <div className="success-icon-wrapper">
          <svg
            className={`success-checkmark ${checkmarkDrawn ? "drawn" : ""}`}
            viewBox="0 0 52 52"
            aria-hidden="true"
          >
            <circle
              className="success-checkmark-circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              className="success-checkmark-check"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M14 26l8 8 16-16"
            />
          </svg>
        </div>
        <h1 className="success-title">{t("success.title")}</h1>
        <p className="success-message">
          {t("success.message")}
        </p>
      </div>
    </div>
  );
};

